<template>
  <el-dialog
    :title="title"
    width="1000px"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    class="limit-line-areas-dialog"
  >
    <el-form :model="form" :rules="rules" label-width="100px" class="from"  ref="ruleForm">
        <el-row :gutter="10">
            <el-col :span="11">
                <el-form-item label="服务平台"  prop="siteName">
                    <advance-dialog
                        v-model="form.siteName"
                        :params="siteParams"
                        :mValue="form.siteName"
                        :disabled="title === '编辑'"
                        @getAdvanceValue="getSelectValue">
                    </advance-dialog>
                </el-form-item>
            </el-col>
            <el-col :span="13">
                <el-form-item label="省/市/区/镇"  prop="addressCode">
                     <muchAddressCascader
                          v-if="title === '新增'"
                          placeholder="请选择 省 / 市 / 区 / 镇"
                          clearable
                          v-model="form.addressCode"
                          @getAddress="muchGetAddress"
                          :minLayers="4"
                          :basicProps="basicProps"
                    ></muchAddressCascader>
                    <addressCascader
                        v-else
                        :minLayers="4"
                        v-model="form.addressCode"
                        :disabled="title === '编辑'"
                        placeholder="请选择 省 / 市 / 区 / 镇"
                        @getAddress="getAddress"
                    ></addressCascader>

                </el-form-item>
            </el-col>
            <el-col :span="11">
                <el-form-item label="最大可用车型"  prop="maximumEquipmentType">
                    <el-select v-model="form.maximumEquipmentType" filterable clearable placeholder="请选择最大可用车型">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="13">
                <el-form-item label="区域分类"  prop="areaClassify">
                    <el-input
                        v-model.trim="form.areaClassify"
                        maxlength="20"
                        placeholder="请输入区域分类"
                        clearable>
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :span="11">
                <el-form-item label="启用状态"  prop="limitStatus">
                    <el-select v-model="form.limitStatus" placeholder="请选择状态">
                        <el-option label="启用" :value="0"></el-option>
                        <el-option label="停用" :value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
             <el-col :span="24">
              <el-form-item label="描述"  prop="remark">
                 <el-input
                    v-model.trim="form.remark"
                    placeholder="请输入描述"
                    maxlength="100"
                    clearable>
                </el-input>
            </el-form-item>
        </el-col>
        </el-row>
  </el-form>
  <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSure" :loading="loading">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import addressCascader from '@/components/lots/addressCascader';
import muchAddressCascader from './AddressSelect';
import advanceDialog from '@/components/lots/otpAdvance';
import { saveDate, editDate, getCarListApi } from '../../../api/limitLineAreas';

export default {
    components: { addressCascader, advanceDialog, muchAddressCascader },
    data() {
        return {
            basicProps: { multiple: true },
            form: {
                siteCode: '',
                siteName: '',
                addressCode: [],
                regionList: [], // 地址多选传给后端的参数
                limitStatus: '',
                provinceCode: '',
                provinceName: '',
                cityCode: '',
                cityName: '',
                districtCode: '',
                districtName: '',
                maximumEquipmentType: '',
                maximumEquipmentName: '',
                areaClassify: '',
                remark: '',
                costCoefficient: '1'
            },
            loading: false,
            options: [],
            MAX_CAR_TYPE: {},
            siteParams: {
                name: '服务平台',
                value: 'siteName',
                unfold: true,
                span: 4,
                type: 'advance',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', 'value': '平台名称' },
                    { prop: 'escoCompanyNo', 'value': '平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', 'value': '平台名称' },
                    { prop: 'escoCompanyNo', 'value': '平台编码' }
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
            },
            rules: {
                areaClassify: [
                    { required: true, message: '请输入区域分类', trigger: 'blur' }
                ],
                limitStatus: [
                    { required: true, message: '请选择是否启用', trigger: 'change' }
                ],
                maximumEquipmentType: [
                    { required: true, message: '请选择最大可用车型', trigger: 'change' }
                ],
                addressCode: [
                    { required: true, message: '请选择 省 / 市 / 区', trigger: 'change' }
                ],
                siteName: [
                    { required: true, message: '请选择服务平台', trigger: 'change' }
                ]
            }
        };
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '新增'
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    mounted() {
        if (this.title === '编辑') {
            this.form = this.rowData;
            this.form.addressCode = [this.rowData.provinceCode, this.rowData.cityCode, this.rowData.districtCode, this.rowData.townCode];
        }
        this.getCarList();
    },
    methods: {
        muchGetAddress(labels) {
            const arr = [];
            labels.forEach((item, index) => {
                arr.push([...this.form.addressCode[index], ...item]);
            });
            let areaList = [];
            areaList = arr.map(item => {
                const [provinceCode, cityCode, districtCode, townCode, provinceName, cityName, districtName, townName] = item;
                return {
                    provinceCode, cityCode, districtCode, townCode, provinceName, cityName, districtName, townName
                };
            });
            this.form.regionList = areaList;
            if (areaList.length) {
                ['provinceCode', 'cityCode', 'districtCode', 'provinceName', 'cityName', 'districtName'].forEach((key, index) => {
                    this.form[key] = areaList[0][key] || '';
                });
            }
        },
        getAddress(labels) {
            if (labels) {
                ['provinceName', 'cityName', 'districtName', 'townName'].forEach((key, index) => {
                    this.form[key] = labels[index] || '';
                });
            }
            if (this.form.addressCode.length) {
                [this.form.provinceCode, this.form.cityCode, this.form.districtCode, this.form.townCode] = this.form.addressCode;
            }
        },
        getSelectValue(data) {
            this.form = {
                ...this.form,
                ...data
            };
        },
        handleClose() {
            this.form = {};
            this.$emit('handleClose');
        },
        handleSure() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.form.maximumEquipmentName = this.MAX_CAR_TYPE[this.form.maximumEquipmentType] || '';
                    if (this.form.id) {
                        editDate(this.form).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('编辑成功');
                                this.form = {};
                                this.$emit('handleClose', true);
                            }
                        }).finally(() => {
                            this.loading = false;
                        });
                    } else {
                        saveDate(this.form).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('新增成功');
                                this.form = {};
                                this.$emit('handleClose', true);
                            }
                        }).finally(() => {
                            this.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        getCarList() {
            this.options = [];
            this.MAX_CAR_TYPE = {};
            const params = {
                queryType: 'ALL'
            };
            getCarListApi(params).then(res => {
                if (res) {
                    res.data.equipmentDictList.forEach(item => {
                        this.options.push({ label: item.equipmentName, value: item.equipmentType });
                        this.MAX_CAR_TYPE[item.equipmentType] = item.equipmentName;
                    });
                }
            });
        }
    }
};
</script>
<style lang="less">
.limit-line-areas-dialog{
    .el-date-editor--datetimerange.el-input__inner, .el-select {
        width: 100%;
    }
    .from{
        .el-form-item__content .el-input-group {
            vertical-align: middle;
        }
        .el-form-item__label,.el-form-item__content {
            line-height: 40px;
        }
        .el-form-item {
            margin-bottom: 14px;
        }
    }
}
</style>
